export const CurrencyCode = Object.freeze({
  USD: 'USD',
  INR: 'INR',
  BRL: 'BRL',
});

export const VByVRequiredCurrencyCodes = Object.freeze([CurrencyCode.INR]);
